import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardBody, CardHeader, Col,  Progress, Table } from 'reactstrap';
import { H5, Image } from '../../../AbstractElements';
import { EmployeeStatusTitle } from '../../../Constant';
import { EmployeeStatusTable } from '../../../Data/Widgets/general/index';

const EmployeeStatus = () => {
  return (
    <Fragment>
      <Col xl='6' className='xl-50 box-col-6'>
        <Card className='employee-status'>
          <CardHeader className='pb-0'>
            <H5>{EmployeeStatusTitle}</H5>
          </CardHeader>
          <CardBody>
            <Table className='user-status' responsive borderless>
              <thead>
                <tr>
                  {EmployeeStatusTable.head.map((item, i) => (
                    <th key={i} scope='col'>
                      {item}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {EmployeeStatusTable.body.map((data) => (
                  <tr key={data.id}>
                    <td>
                      <div className='d-flex'>
                        <Image src={data.image} alt='avatar' />
                        <div className='flex-grow-1'>
                          <Link to={`${process.env.PUBLIC_URL}/user-profile`}>
                            <H5>
                              {data.title} <span className='text-muted'>({data.online})</span>
                            </H5>
                          </Link>
                        </div>
                      </div>
                    </td>
                    <td>{data.position}</td>
                    <td>
                      <Progress style={{ height: '8px' }} value={data.skill} color={data.color} />
                    </td>
                    <td className='digits'>{data.exp}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </CardBody>
        </Card>
      </Col>
    </Fragment>
  );
};
export default EmployeeStatus;
